import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.list),function(item){return _c('div',{key:item.id,staticClass:"mb-2"},[_c(VCard,{on:{"click":function($event){return _vm.clickHandler(item.id)}}},[_c('div',{staticClass:"d-flex flex-no-wrap justify-space-between"},[_c('div',[_c(VCardTitle,{staticClass:"text-subtitle-1",domProps:{"textContent":_vm._s(item.name)}})],1)])])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }